var $a99e782553121a2b$exports = {};
$a99e782553121a2b$exports = {
    "negative": `Error`,
    "notice": `Warning`,
    "info": `Information`,
    "positive": `Success`
};


export {$a99e782553121a2b$exports as default};
//# sourceMappingURL=en-US.mjs.map
